export default "__VITE_ASSET__Cqep1sOp__"